import React from 'react';
import './styles.css'
import Logo from '../Logo';

const Footer = () => {
  return (
    <footer>
        <p>We are a group of five who love tasty donuts that are warm and ready to eat!</p>
        <Logo />
    </footer>
  )
}

export default Footer;